/* eslint-disable max-classes-per-file -- <ng-sidebar-container> and <ng-sidebar> only work as a pair */
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector -- in-house drop-in that kept the replaced library's template API
    selector: 'ng-sidebar-container',
    template: `<ng-content></ng-content>`,
    styles: [`
    :host {
      display: block;
      position: relative;
      min-height: 100vh;
    }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarContainerComponent {}

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector -- in-house drop-in that kept the replaced library's template API
    selector: 'ng-sidebar',
    template: `
    @if (opened && showBackdrop) {
      <div
        class="sidebar-backdrop"
        (click)="onBackdropClick()"
      ></div>
    }
    <div
      class="sidebar-panel"
      [class.sidebar-open]="opened"
      [class.sidebar-right]="position === 'right'"
      [class.sidebar-left]="position !== 'right'"
      >
      <ng-content></ng-content>
    </div>
    `,
    styles: [`
    .sidebar-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 3;
    }

    .sidebar-panel {
      position: fixed;
      top: 0;
      height: 100%;
      width: 70%;
      max-width: 950px;
      background: var(--bs-light, #f8f9fa);
      box-shadow: 0 0 10px rgba(200, 200, 200, 0.15);
      z-index: 3;
      overflow-y: auto;
      overflow-x: hidden;
      transition: transform 0.3s ease-in-out;
    }

    .sidebar-right {
      right: 0;
      transform: translateX(100%);
    }

    .sidebar-right.sidebar-open {
      transform: translateX(0);
    }

    .sidebar-left {
      left: 0;
      transform: translateX(-100%);
    }

    .sidebar-left.sidebar-open {
      transform: translateX(0);
    }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarComponent {
  @Input() opened: boolean = false;
  @Output() openedChange = new EventEmitter<boolean>();

  @Input() position: 'left' | 'right' = 'left';
  @Input() showBackdrop: boolean = true;
  @Input() closeOnClickOutside: boolean = true;
  @Input() closeOnClickBackdrop: boolean = true;
  @Input() mode: 'over' | 'push' = 'over';

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix -- in-house drop-in that kept the replaced library's template API
  @Output() onClosed = new EventEmitter<void>();

  onBackdropClick(): void {
    if (this.closeOnClickBackdrop) {
      this.opened = false;
      this.openedChange.emit(false);
      this.onClosed.emit();
    }
  }
}
